import CoveringSpinner from '../../../Atoms/CoveringSpinner/CoveringSpinner'
import { useIsSkuBaseInAnyList } from '../../../Contexts/UserSpecificProductDataStore/UserSpecificProductDataStore'
import styles from './AddToList.module.scss'

import React, { useContext } from 'react'

import { AddToCartExperienceContext } from 'Contexts/AddToCartExperienceContext/AddToCartExperienceContext'

import Svg from 'Atoms/Svg'

const AddToList = ({ enabled, skuBaseNumber, productPageId }) => {
  const { handleAddToListPRP, addToListSkuLoading } = useContext(AddToCartExperienceContext)
  const isAddedToList = useIsSkuBaseInAnyList(skuBaseNumber)

  if (!enabled) {
    return false
  }

  return (
    <>
      <div
        className={styles.wrapper}
        role={'button'}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          handleAddToListPRP(productPageId, skuBaseNumber)
        }}
        data-testid={`add_to_list_prp_${productPageId}`}
        aria-label={`add to list`}
      >
        <CoveringSpinner isLoading={addToListSkuLoading === skuBaseNumber} brand={'primary'}>
          <Svg
            size={1.25}
            tone={'subtle'}
            brand={isAddedToList ? 'secondarypalette_purple' : null}
            icon={isAddedToList ? 'heart-selected' : 'heart'}
            hoverable={!isAddedToList}
          />
        </CoveringSpinner>
      </div>
    </>
  )
}

export default AddToList
